import { baseApi } from "../redux/baseAPI";

export const AppApi = baseApi.injectEndpoints({
  tagTypes: [],
  endpoints: (builder) => ({
    getFoxitSignature: builder.query({
      query: (body) => {
        return {
          url: `/efax/get_signatures.json`,
          method: "GET",
          params: body,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
    saveFoxitSignature: builder.mutation({
      query: (body) => {
        return {
          url: `/efax/add_signature.json`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }), 
    deleteFoxitSignature: builder.mutation({
      query: (body) => {
        return {
          url: `/efax/delete_signature.json`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});

export const {
  useGetFoxitSignatureQuery,
  useSaveFoxitSignatureMutation,
  useDeleteFoxitSignatureMutation,
} = AppApi;
